import {
  GetRegistriesParams,
  GetRegistriesResponse,
  RegistriesServiceCapabilities,
} from './registries.types'

export const registriesService = ({
  client,
}: RegistriesServiceCapabilities) => ({
  getRegistries: (args: GetRegistriesParams) =>
    client.get<GetRegistriesResponse>(`/v1/registries`, {
      params: args,
    }),
})
